import { render } from "./KindAi.vue?vue&type=template&id=50ab302a&lang=true"
import script from "./KindAi.vue?vue&type=script&lang=js"
export * from "./KindAi.vue?vue&type=script&lang=js"

import "./KindAi.vue?vue&type=style&index=0&id=50ab302a&lang=css"
script.render = render

export default script